import AnalyticsProvider from '../provider/AnalyticsProvider'

class Status {
  private provider: AnalyticsProvider
  private status: boolean
  private message: string

  constructor(provider: AnalyticsProvider, status: boolean, message = '') {
    this.provider = provider
    this.status = status
    this.message = message
  }

  has(provider: () => AnalyticsProvider): boolean {
    return provider.prototype.constructor.name === this.provider.constructor.name
  }

  public getProvider(): AnalyticsProvider {
    return this.provider
  }

  public setProvider(provider: AnalyticsProvider): void {
    this.provider = provider
  }

  public isStatus(): boolean {
    return this.status
  }

  public setStatus(status: boolean): void {
    this.status = status
  }

  public getMessage(): string {
    return this.message
  }

  public setMessage(message: string): void {
    this.message = message
  }
}

export default Status
